/**
 * @generated SignedSource<<edb2b32462c2d7b1ddaa66af6ef563fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditMainArchiveMutation$variables = {
  id: string;
};
export type RoutineEditMainArchiveMutation$data = {
  readonly routine: {
    readonly archiveRoutine: {
      readonly canBeUnarchived: boolean;
      readonly id: string;
      readonly isArchived: boolean;
    } | null;
  } | null;
};
export type RoutineEditMainArchiveMutation = {
  response: RoutineEditMainArchiveMutation$data;
  variables: RoutineEditMainArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "archiveRoutine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canBeUnarchived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditMainArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineEditMainArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "538cb6bde83e2277e5061e35c7c84435",
    "id": null,
    "metadata": {},
    "name": "RoutineEditMainArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineEditMainArchiveMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    archiveRoutine {\n      id\n      isArchived\n      canBeUnarchived\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "be0beb24732f583a72a493002474ebbc";

export default node;
